import _regeneratorRuntime from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { spaceActions } from 'store/space';
import { GetAllRetailsAPI, GetRegionsAPI } from 'api/space';
import SubHeader from 'components/common/SubHeader';
import RetailListService from 'components/retail/_list';
import { SubHeaderOptions } from 'constants/index';
import { ERROR_500 } from 'constants/message';
import { useRouter } from 'next/router';

var RetailList = function RetailList(_ref) {
  var error = _ref.error;
  var router = useRouter();
  useEffect(function () {
    if (error) {
      alert(ERROR_500);
      router.push('/');
    }
  }, [error, router]);

  if (error) {
    return null;
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SubHeader, {
      options: SubHeaderOptions,
      selected: "\uB9AC\uD14C\uC77C"
    }), /*#__PURE__*/_jsx(RetailListService, {})]
  });
};

RetailList.getInitialProps = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var store, regions, retails;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            store = _ref2.store;
            _context.next = 3;
            return GetRegionsAPI();

          case 3:
            regions = _context.sent;
            _context.next = 6;
            return GetAllRetailsAPI();

          case 6:
            retails = _context.sent;

            if (!(regions.status >= 400 || retails.status >= 400)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", {
              error: true
            });

          case 9:
            store.dispatch(spaceActions.getRegions(regions.data));
            store.dispatch(spaceActions.getRetails(retails.data));
            return _context.abrupt("return", {
              error: false
            });

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();

export default RetailList;